module.exports = __webpack_public_path__ + "img/palette-1_fg_en.c3a2bba.jpg";